export default "__VITE_ASSET__Ch72kkj9__"